import Vue from 'vue'
// Flash component
import Flash from '@/components/Flash.vue'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.events = new Vue()

window.flash =
  window.flash ||
  function (message: string, level = 'success', timeout = 5000) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return window.events.$emit('flash', { message, level, timeout })
  }

// Register global component - Flash
Vue.component('flash', Flash)
